var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-head inner"},[_c('div',{key:"skip",staticClass:"timeline-head-item"},[_vm._v("SKIP TO")]),_vm._l((_vm.item.groups),function(group,index){return _c('div',{key:index,staticClass:"timeline-head-item"},[_vm._v(_vm._s(group.text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }